import React, {useEffect, useState, useRef} from 'react'
import {PageContent, UploadMedia} from '@/components/organisms'
import {SaveCancelFooter} from '@/components/molecules'
import {useNavigate, useParams} from 'react-router-dom'
import {Modal} from '@/components/atoms'
import {MODAL_TYPE} from '@/utils/constants/globalStyle'
import {ROUTES} from '@/utils/constants/routesConstants'

const MediaGalleryEdit = ({formData, handleSave, onDataChange, productId}) => {
  const [isCancel, setIsCancel] = useState(false)
  const navigate = useNavigate()
  const {id} = useParams()
  const [publishDisabled, setPublishDisabled] = useState(false)
  const mediaCardFormData = formData?.media

  const handleCancel = () => {
    setIsCancel(!isCancel)
  }

  const onClickPrimaryButton = () => {
    navigate(`${ROUTES.PRODUCT_REVIEW.replace(':id', id)}`, { state: { selectedTabNumb: 1 } })
  }

  const onClickSecondaryButton = () => {
    setIsCancel(!isCancel)
  }

  const handleSaveMedia = () => {
    handleSave()
  }

  return (
    <>
      <PageContent className="media-gallery-component bg-neutral-800 text-white" pageContentWrapperClassName="relative">
        <UploadMedia
          mediaCardFormData={mediaCardFormData}
          setMediaCardFormData={onDataChange}
          setPublishDisabled={setPublishDisabled}
          mediaText={'Product'}
          productId={productId}
        />
      </PageContent>
      {isCancel ? (
        <Modal
          type={MODAL_TYPE.SMALL}
          showModal={isCancel}
          onCloseModal={handleCancel}
          title="Are you sure you want to cancel?"
          text={'The changes will not be saved.'}
          showPrimaryButton={true}
          primaryButtonText="Yes"
          onClickPrimaryButton={onClickPrimaryButton}
          showSecondaryButton={true}
          secondaryButtonText="No"
          onClickSecondaryButton={onClickSecondaryButton}
          footerProps={{
            size: 'medium',
            type: 'primary',
          }}
          isDark={true}
        />
      ) : null}
      <SaveCancelFooter
        handleCancel={handleCancel}
        nextAction={handleSaveMedia}
        isReview={true}
        hideSaveDraft={true}
        FormError={publishDisabled}
      />
    </>
  )
}

export default MediaGalleryEdit
